function Japan({ dimensions }) {
  const baseXml = `
  <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_521_1422)">
  <path d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z" fill="#F0F0F0"/>
  <path d="M16 22.9565C19.8419 22.9565 22.9565 19.8419 22.9565 16C22.9565 12.158 19.8419 9.04346 16 9.04346C12.158 9.04346 9.04346 12.158 9.04346 16C9.04346 19.8419 12.158 22.9565 16 22.9565Z" fill="#D80027"/>
  </g>
  </svg>

  `;

  return baseXml;
}

export default Japan;
